
const SECOND = 1000;
const MINUTE = 60000;
const HOUR = 3600000;
const DAY = 86400000;
const YEAR = 31536000000;

const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
/**
 * Format elapsed time since
 * @returns string
 */
export function formatTimeSinceShort(timestamp: number) {
	if (!timestamp) {
		return "n/a";
	}

	// @ts-ignore
	const elapsed = new Date() - timestamp;
	if (elapsed < MINUTE) {
		return Math.floor(elapsed / SECOND) + 's';
	}
	if (elapsed < HOUR) {
		return Math.floor(elapsed / MINUTE) + 'm';
	}
	if (elapsed < DAY) {
		return Math.floor(elapsed / HOUR) + 'h';
	}
	const d = new Date(timestamp);
	if (elapsed < YEAR) {
		return d.getDate() + ' ' + monthNames[d.getMonth()];
	}
	return '' + d.getFullYear();
}
